import React from 'react';
import classNames from 'classnames';

const Button = ({
  label,
  icon,
  light,
  dark,
  login,
  copy,
  addTeammate,
  removeTeammate,
  forgottenPassword,
  showText,
  type,
  onClick,
  disabled,
}) => {
  const btnClass = classNames({
    'button button-light': light,
    'button button-dark': dark,
    'button button-login': login,
    'button button-copy': copy,
    'button-add-teammate': addTeammate,
    'button-remove-teammate': removeTeammate,
    'button-login-form': forgottenPassword,
    'button-show-data': showText,
  });

  return (
    <button type={type} className={btnClass} onClick={onClick} disabled={disabled}>
      {icon}
      {label}
    </button>
  );
};

export default Button;
